import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

//interfaces
import { OrderInterface } from '../shared/interfaces';

//services
import { OrderService } from '../shared/services';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  public qrCodeData: string = 'https://forms.gle/FPz3jwL6QYrYJEXy9';

  constructor(
    private router: Router
  ) {
    //this needs tro move to a guard at some point...
    let shop = OrderService.shop.getValue();
    let shopCode = OrderService.shopCode.getValue();
    let apiKey = OrderService.kioskApiKey.getValue();
    if (!shop) {
      shop = localStorage.getItem('selectedShop');
      if (shop) {
        OrderService.shop.next(shop);
        //this.qrCodeData = this.qrCodeData + shop;
      } else {
        router.navigate(['/config']);
      }
    }
    if (!shopCode) {
      shopCode = localStorage.getItem('selectedShopCode');
      if (shopCode) {
        OrderService.shopCode.next(shopCode);
      } else {
        router.navigate(['/config']);
      }
    }
    if (!apiKey) {
      apiKey = localStorage.getItem('apiKey');
      if (apiKey) {
        OrderService.kioskApiKey.next(apiKey);
      } else {
        router.navigate(['/config']);
      }
    }
  }

  ngOnInit(): void {
    OrderService.orderPreview.next({ new: null, order: null })
    OrderService.order.next(null);
    OrderService.employee.next(false);
  }

  public start() {
    OrderService.order.next(new OrderInterface());
    this.router.navigate(['/basket'])
  }

}
